<template>
  <div class="detail_content">
    <div class="detail_label">
      {{titleLabel}}
    </div>
    <textarea rows='4' cols='40' class='detail_input_field' v-model='bindValue' @input="inputUpdate"></textarea>
  </div>
</template>

<script>
export default {
  props: {
    titleLabel: String,
    bindValue: String
  },
  data () {
    return {
    }
  },
  computed: {
    requiredItemLabel () {
      return this.$store.state.error.requiredItemLabel
    }
  },
  methods: {
    inputUpdate (e) {
      this.$emit('inputUpdate', e)
    }
  }
}
</script>
<style scoped>
.detail_input_field {
  height: 110px;
  width: calc(100% - 60px);
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/textAreaBindSection.vue